/* ******* USAGE *******
 * http://jsfiddle.net/KyleMit/X9tgY/

$("#myTable td").contextMenu({
    menuSelector: "#contextMenu",
    menuSelected: function (invokedOn, selectedMenu) {
        var msg = "You selected the menu item '" + selectedMenu.text() +
            "' on the value '" + invokedOn.text() + "'";
        alert(msg);
    }
});

 *
 */

(function contextMenu($, window) {
    function isContextMenuEmpty($menu)
    {
        if (!$menu.length) {
            return true;
        }

        // Actionable items only — ignore dividers / empty wrappers
        return $menu.find('a, button, [role="menuitem"]').length === 0;
    }

    function restoreContextMenu($menu)
    {
        let $home = $menu.data('naisContextHome');
        if ($home && $home.length && $menu.parent()[0] !== $home[0]) {
            $menu.appendTo($home);
        }
    }

    function hideAllContextMenus(fade)
    {
        $('.contextMenu').each(function hideEach() {
            let $menu = $(this);
            if (fade) {
                $menu.fadeOut(200, function afterFade() {
                    restoreContextMenu($menu);
                });
            } else {
                $menu.hide();
                restoreContextMenu($menu);
            }
        });
    }

    /**
     * Keep a fixed-position menu inside the viewport.
     * @param {number} mouse clientX / clientY
     * @param {number} menuSize menu width / height
     * @param {number} winSize window width / height
     * @returns {number}
     */
    function getMenuPosition(mouse, menuSize, winSize)
    {
        let margin = 8;
        let position = mouse;

        if (mouse + menuSize + margin > winSize) {
            if (mouse - menuSize >= margin) {
                position = mouse - menuSize;
            } else {
                position = Math.max(margin, winSize - menuSize - margin);
            }
        }

        return position;
    }

    $.fn.contextMenu = function contextMenuFcd(settings) {
        return this.each(function contextMenuEach() {
            let $host = $(this);

            // Open context menu
            $host.off('contextmenu.naisContext').on('contextmenu.naisContext', function contectMenuOn(e) {
                hideAllContextMenus(false);

                // return native menu if pressing control
                if (e.ctrlKey) {
                    return;
                }

                // Cache menu node — after portaling to <body>, descendant selectors break
                let $menu = $host.data('naisContextMenu');
                if (!$menu || !$menu.length || !$.contains(document, $menu[0])) {
                    $menu = $(settings.menuSelector);
                    if (!$menu.length) {
                        $menu = $host.find('.contextMenu').first();
                    }
                    $host.data('naisContextMenu', $menu);
                }

                if (isContextMenuEmpty($menu)) {
                    return false;
                }

                if (!$menu.data('naisContextHome')) {
                    $menu.data('naisContextHome', $menu.parent());
                }

                // Portal to body so position:fixed is viewport-relative (not clipped by table overflow)
                $menu.appendTo(document.body);

                $menu
                    .data('invokedOn', $(e.target))
                    .show()
                    .css({
                        position: 'fixed',
                        left: getMenuPosition(e.clientX, $menu.outerWidth(), $(window).width()),
                        top: getMenuPosition(e.clientY, $menu.outerHeight(), $(window).height())
                    })
                    .off('click.naisContextItem')
                    .on('click.naisContextItem', 'a', function onClickA(e) {
                        $menu.hide();
                        restoreContextMenu($menu);

                        let $invokedOn = $menu.data('invokedOn');
                        let $selectedMenu = $(e.target);
                        if (settings.menuSelected !== undefined) {
                            settings.menuSelected.call(this, $invokedOn, $selectedMenu);
                        }
                    });

                // make sure menu closes on any click
                $('body').off('click.contextMenu').on('click.contextMenu', () => {
                    hideAllContextMenus(true);
                });

                return false;
            });
        });
    };
}(jQuery, window));
